import { CreateAppointmentRequest } from "@shared/dtos/requests/appointmentRequests.dto"
import {
  AgendaSlotsResponse,
  AppointmentCreationResponse,
  PatientHisAppointmentResponse,
} from "@shared/dtos/responses/appointmentResponses.dto"

import { axiosPatient } from "./generic/AxiosInterceptor/AxiosInterceptor"

/**
 * Patient requests the available slots (initial step to book an appointment)
 * @param pageId: Site page, from a practice, determining which agendas/blocks to show
 * @param platoSessionId: Optional Plato session ID for outcome-based filtering
 */
export const getAgendaSlots = (pageId: string, platoSessionId?: string): Promise<AgendaSlotsResponse[]> => {
  const baseUrl = `/patient/appointments/slots/${pageId}`
  const url = platoSessionId ? `${baseUrl}?platoSessionId=${platoSessionId}` : baseUrl

  return axiosPatient({
    url,
    method: "get",
  }).then((resp) => resp.data)
}

export const addByPatient = (data: CreateAppointmentRequest): Promise<AppointmentCreationResponse> => {
  return axiosPatient({
    url: "/patient/appointments",
    method: "post",
    data: data,
  }).then((resp) => resp.data)
}

export const getHisAppointments = (): Promise<PatientHisAppointmentResponse[]> => {
  return axiosPatient({
    url: "/patient/hisappointments",
    method: "get",
  }).then((resp) => resp.data)
}

export const cancelHisAppointment = (hisAppointmentId: string): Promise<void> => {
  return axiosPatient({
    url: `/patient/hisappointments/${hisAppointmentId}`,
    method: "delete",
  }).then(() => undefined)
}
